import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/entities/Arbeitsbereich';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

function istAktiv(von: Date, bis: Date) {
  const today = dayjs();
  return (
    dayjs(von).isSameOrBefore(today, 'day') &&
    dayjs(bis).isSameOrAfter(today, 'day')
  );
}

function istAbgeschlossen(von: Date, bis: Date) {
  const today = dayjs();
  return dayjs(von).isBefore(today, 'day') && dayjs(bis).isBefore(today, 'day');
}

function istGeplant(von: Date, bis: Date) {
  const today = dayjs();
  return dayjs(von).isAfter(today, 'day') && dayjs(bis).isAfter(today, 'day');
}

export interface Station {
  id: string;
  von: Date;
  bis: Date;
  abschnittId: string;

  get istAktiv(): boolean;
  get istAbgeschlossen(): boolean;
  get istGeplant(): boolean;
}

export class ArbeitsbereichStation implements Station {
  constructor({
    von,
    bis,
    arbeitsbereich,
    bereichsleiter,
    abschnittId,
    lernziele,
    id,
  }: {
    id: string;
    von: Date;
    bis: Date;
    arbeitsbereich: Arbeitsbereich;
    bereichsleiter?: Mitarbeiter;
    abschnittId: string;
    lernziele: string;
  }) {
    this.id = id;
    this.von = von;
    this.bis = bis;
    this.abschnittId = abschnittId;
    this.arbeitsbereich = arbeitsbereich;
    this.bereichsleiter = bereichsleiter;
    this.lernziele = lernziele;
  }

  id: string;
  von: Date;
  bis: Date;
  abschnittId: string;
  arbeitsbereich: Arbeitsbereich;
  bereichsleiter?: Mitarbeiter;
  lernziele: string;

  get istAktiv() {
    return istAktiv(this.von, this.bis);
  }

  get istAbgeschlossen(): boolean {
    return istAbgeschlossen(this.von, this.bis);
  }

  get istGeplant(): boolean {
    return istGeplant(this.von, this.bis);
  }
}

export class AbwesenheitsStation implements Station {
  constructor({
    von,
    bis,
    titel,
    abschnittId,
    id,
  }: {
    von: Date;
    bis: Date;
    titel: string;
    abschnittId: string;
    id: string;
  }) {
    this.id = id;
    this.von = von;
    this.bis = bis;
    this.abschnittId = abschnittId;
    this.titel = titel;
  }

  id: string;
  von: Date;
  bis: Date;
  abschnittId: string;
  titel: string;

  get istAktiv() {
    return istAktiv(this.von, this.bis);
  }

  get istAbgeschlossen(): boolean {
    return istAbgeschlossen(this.von, this.bis);
  }

  get istGeplant(): boolean {
    return istGeplant(this.von, this.bis);
  }
}
